import { Device, until } from '@helpers/media';
import { withMotionMax } from '@hoc/withMotionMax';
import useMedia from '@hooks/useMedia';
import CarouselProvider from '@stories/Components/Misc/Carousels/Carousel/CarouselProvider/CarouselProvider';
import Pagination from '@stories/Components/Misc/Carousels/Carousel/Pagination/Pagination';
import { MotionConfig } from 'framer-motion';
import * as React from 'react';
import S from './FullWidthCarousel.styles';
function FullWidthCarousel(props) {
    const paddingOffset = useMedia([until(Device.MobileLarge), until(Device.Desktop)], [100, 50], 0);
    if (!props.items || props.items.length === 0) {
        return null;
    }
    return (React.createElement(S.Container, null,
        props.title && React.createElement(S.Title, null, props.title),
        React.createElement(MotionConfig, { transition: { duration: 0.3, ease: 'easeOut' } },
            React.createElement(CarouselProvider, { count: props.items.length, paddingOffset: !props.noPaddingOffset ? paddingOffset : 0 },
                React.createElement(S.CarouselWrapper, null,
                    React.createElement(S.Track, { trackMutations: true }, props.items.map((item, i) => (React.createElement(S.Item, { key: `full-carousel-${item.id}` }, props.renderItem(item, i)))))),
                React.createElement(Pagination, null)))));
}
export default withMotionMax(FullWidthCarousel);
